/**
 * Defines supported badges (this list should grow as we support more badges).
 * @type {string[][]}
 */
export const supportedTypes = [
  ['desktop', 'free', 'mid'],
  ['desktop', 'start', 'header'],
  ['desktop', 'premium', 'header'],
  ['desktop', 'start', 'mid'],
  ['desktop', 'premium', 'mid'],
  ['desktop', 'start', 'footer'],
  ['desktop', 'premium', 'footer'],
  ['desktop', 'premium', 'island'],
  ['mobile', 'free', 'mid'],
  ['mobile', 'start', 'header'],
  ['mobile', 'start', 'mid'],
  ['mobile', 'start', 'footer'],
  ['mobile', 'premium', 'header'],
  ['mobile', 'premium', 'footer'],
  ['mobile', 'premium', 'mid'],
  ['mobile', 'premium', 'island']
];

